module.exports = __webpack_public_path__ + "static/media/stairs.9ec4892c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/backgrounds/stairs.jpg
// module id = 235
// module chunks = 0